import React from 'react'
import { Outlet, ScrollRestoration } from 'react-router-dom'
import { useLaunchDarkly } from '@hooks/useLaunchDarkly'
import { ErrorBoundary } from '@components/error/ErrorBoundary'
import { Loading } from '@components/ui/Loading'
import { DevUIWrapper } from '@utils/DevUIPanel/DevUIWrapper'
import { AppProviders } from './providers/AppProviders'
import { AppRouter } from './routes/AppRouter'

export interface MakoAppProps {}

/**
 * Main application component
 * Responsible for initializing LaunchDarkly and wrapping the app with providers and router
 */
const MakoApp: React.FC<MakoAppProps> = () => {
  const { LDProvider, isLoading } = useLaunchDarkly()

  if (isLoading || !LDProvider) {
    return (
      <AppRouter>
        <Loading
          heading=""
          subheading=""
        />
      </AppRouter>
    )
  }

  return (
    <LDProvider>
      <ErrorBoundary>
        <AppRouter>
          <AppProviders>
            <ScrollRestoration />
            <DevUIWrapper />
            <Outlet />
          </AppProviders>
        </AppRouter>
      </ErrorBoundary>
    </LDProvider>
  )
}

export default MakoApp
